// ArmazenaVariaveisInscricao.js

import ArmazenaVariaveis from './ArmazenaVariaveis.js';

class ArmazenaVariaveisInscricao extends ArmazenaVariaveis {
  // Métodos adicionais específicos para a classe AppDataLogin, se necessário
  static atualizarDados(objeto) {
    super.atualizarDados(objeto);
    localStorage.setItem("dados_pre_inscricao",this.dados);

  }
}

export default ArmazenaVariaveisInscricao;
